import {
  LpFeeType,
  LpFeeCalculationBasis,
  LpArrearsCalculation,
  LpFeeStartDate,
} from 'further-types/lp/lp-fee-template';
import { FeesEqualisationTreatment } from 'further-types/lp/equalisation';

export const emptyFee = {
  name: '',
  type: LpFeeType.RecurringPercentage,
  calculationBasis: LpFeeCalculationBasis.CommittedCapital,
  feeExTax: 0,
  salesTaxRate: 0,
};

export const createEmptyFeeTemplate = (isDefaultFeeTemplate: boolean) => ({
  name: '',
  isDefaultFeeTemplate,
  arrearsCalculation: LpArrearsCalculation.BasedOnPeriodEndingAmount,
  feeStartDate: LpFeeStartDate.FundFirstCloseDate,
  feesEqualisationTreatment: FeesEqualisationTreatment.Full,
  lpFeeTemplateFees: [{ ...emptyFee }],
});
